import './ComparisonLoader.css'

function LoaderPanel({ side, rows }) {
  return (
    <div className={`cl-panel cl-panel-${side}`}>
      <div className="cl-panel-face">
        <span className="cl-panel-title" />
        {rows.map((width, index) => (
          <span key={index} className="cl-panel-row" style={{ '--cl-row-width': width }} />
        ))}
        <span className="cl-panel-total" />
      </div>
      <div className="cl-panel-edge" />
      <div className="cl-panel-glow" />
    </div>
  )
}

export default function ComparisonLoader() {
  return (
    <main className="compare-carts-page compare-state">
      <div className="comparison-loader">
        <div className="cl-scene" aria-hidden="true">
          <div className="cl-stage">
            <LoaderPanel side="a" rows={['72%', '54%', '64%']} />
            <LoaderPanel side="b" rows={['58%', '76%', '48%']} />
            <div className="cl-beam" />
          </div>
          <div className="cl-shadow" />
        </div>
        <p className="cl-label" role="status" aria-live="polite">
          Chargement des paniers…
        </p>
      </div>
    </main>
  )
}
